import axiosInstance from "../config/API";

const API_ENDPOINT = "/customer.php";

// Fetch all customers and dropdown data (plans, staff, areas)
export const fetchCustomersApi = async (searchText = "") => {
  const payload = {
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch customers:", response.data);
  return response.data.body || { customer: [], plan: [], area: [], staff: [] };
};

// Add a new customer
export const addCustomerApi = async (customerData) => {
  const payload = {
    name: customerData.name,
    phone: customerData.phone,
    address: customerData.address,
    area_id: customerData.area_id,
    box_no: customerData.box_no,
    plan_id: customerData.plan_id,
    plan_prize: customerData.plan_prize,
    staff_id: customerData.staff_id,
    customer_no: customerData.customer_no,
    current_user_id: customerData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add customer:", response.data);
  return response.data;
};

// Update a customer
export const updateCustomerApi = async (customerData) => {
  const payload = {
    name: customerData.name,
    phone: customerData.phone,
    address: customerData.address,
    area_id: customerData.area_id,
    box_no: customerData.box_no,
    plan_id: customerData.plan_id,
    plan_prize: customerData.plan_prize,
    staff_id: customerData.staff_id,
    customer_no: customerData.customer_no,
    current_user_id: customerData.current_user_id,
    edit_customer_id: customerData.customer_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update customer:", response.data);
  return response.data;
};

// Delete a customer
export const deleteCustomerApi = async (customerId, currentUserId) => {
  const payload = {
    delete_customer_id: customerId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete customer:", response.data);
  return response.data;
};

// Generate customer_no based on area_id
export const generateCustomerNoByAreaApi = async (areaId) => {
  const payload = {
    generate_customer_no: true,
    area_id: areaId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("generate customer_no:", response.data);
  return response.data.body.customer_no || "";
};
